<template>
  <div>
    <div class="main">
      <h2>
        <span class="fl">配送先管理</span>
      </h2>
      <div class="content">
        <input type="text" class="h5" v-model="address.remark" />
        <ul class="form">
          <li>
            <span>氏 名：</span>
            <input type="text" v-model="address.realname" />
          </li>
          <li>
            <span>ローマ字 ：</span>
            <input type="text" v-model="address.nameroma" />
          </li>
          <li>
            <span>会 社名：</span>
            <input type="text" v-model="address.company" />
          </li>
          <li>
            <span>郵 便：</span>
            <input type="text" v-model="address.zip" />
          </li>
          <li>
            <span>住 所：</span>
            <input type="text" v-model="address.address" />
          </li>
          <li>
            <span>ローマ字：</span>
            <input type="text" v-model="address.addressroma" />
          </li>
          <li>
            <span>電 話：</span>
            <input type="text" v-model="address.tel" />
          </li>
          <li>
            <span>携帯番号：</span>
            <input type="text" v-model="address.mobile" />
          </li>
        </ul>
        <!-- <p>
          <input
            type="checkbox"
            name
            id
            :checked="address.def1 == 1"
            @change="addressdef(address.def1, 1)"
          />
          常用配送先に指定
          <input
            type="checkbox"
            name
            id
            style="margin-left: 50px"
            :checked="address.def2 == 1"
            @change="addressdef(address.def2, 2)"
          />
          インボイス配送先に指定
        </p> -->
        <div class="btn">
          <a href="javascript:;" @click="editAddress(1)" v-if="!flag">保存</a>
          <a href="javascript:;" @click="editAddress(2)" v-else>編集</a>
          <a href="javascript:;" @click="address = []">リセット</a>
        </div>
        <div class="container">
          <ol>
            <li>氏名</li>
            <li>会社名</li>
            <li class="flex2">住所</li>
            <li>郵便</li>
            <li>電話</li>
            <li></li>
          </ol>
          <div class="body" v-for="(item, index) in list" :key="index">
            <h6>{{ item.remark }}</h6>
            <div class="site">
              <ul>
                <li>{{ item.realname }}</li>
                <li>{{ item.company }}</li>
                <li class="flex2">{{ item.address }}</li>
                <li>{{ item.zip }}</li>
                <li>{{ item.mobile }}</li>
                <li>
                  <a
                    href="javascript:;"
                    @click="
                      address = item;
                      flag = true;
                    "
                    >編集</a
                  >
                </li>
              </ul>
              <ul>
                <li>{{ item.nameroma }}</li>
                <li></li>
                <li class="flex2">{{ item.addressroma }}</li>
                <li></li>
                <li>{{ item.mobile }}</li>
                <li>
                  <a href="javascript:;" @click="delAddress(index)">削除</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAddress, addAddress1, deleteAddress } from "../../../api/API/site";
import LogisticsTraceVue from "../../footList/LogisticsTrace.vue";
export default {
  data() {
    return {
      flag: false,
      token: localStorage.getItem("token"),
      list: [],
      address: {
        aid: "",
        user_id: "",
        realname: "",
        nameroma: "",
        address: "",
        addressroma: "",
        zip: "",
        mobile: "",
        tel: "",
        company: "",
        def1: "",
        def2: "",
        remark: "",
        status: "",
      },
    };
  },
  created() {
    this.getAddress();
  },
  methods: {
    // 获取地址
    getAddress() {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "getAddress",
        token: this.token,
      };
      getAddress(list).then((res) => {
        console.log(res.data);
        if (res.code != 1) return;
        this.list = [...res.data.delivery, ...res.data.outlet];
        let obj = {};
        this.list = this.list.reduce((pre, cur) => {
          obj[cur.aid] ? "" : (obj[cur.aid] = true && pre.push(cur));
          return pre;
        }, []);
        console.log(this.list);
      });
    },
    // addressdef(def, i) {
    //   console.log(def);
    //   if (i == 1) {
    //     def == 1 ? (this.address.def1 = 0) : (this.address.def1 = 1);
    //   } else {
    //     def == 1 ? (this.address.def2 = 0) : (this.address.def2 = 1);
    //   }
    //   console.log(this.address.def1, this.address.def2);
    // },
    // 修改或者添加
    editAddress(i) {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "addAddressTpl",
        token: this.token,
        company: this.address.company,
        realname: this.address.realname,
        nameroma: this.address.nameroma,
        zip: this.address.zip,
        address: this.address.address,
        addressroma: this.address.addressroma,
        mobile: this.address.mobile,
        remark: this.address.remark,
        def1: 1,
        def2: 1,
        status: 1,
      };
      if (i == 2) {
        list.aid = this.address.aid;
      }
      addAddress1(list).then((res) => {
        if (res.code != 1) return this.$message.error(res.msg);
        this.$message.success("記入成功");
        this.getAddress();
      });
    },
    // 删除地址
    delAddress(i) {
      let list = {
        mod: "inc",
        act: "ordersys",
        str: "deleteAddress",
        token: this.token,
        id: this.list[i].aid,
      };
      deleteAddress(list).then((res) => {
        if (res.code != 1) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.getAddress();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  width: 1208px;
  font-size: 16px;
  margin-bottom: 50px;
  h2 {
    height: 40px;
    background-color: #eee;
    color: #F3C622;
    line-height: 40px;
    padding-left: 20px;
    font-size: 20px;
    .ck {
      margin-right: 30px;
      font-size: 500;
      font-size: 16px;
      img {
        vertical-align: middle;
      }
    }
  }
  .content {
    border: 1px solid #ccc;
    padding: 40px 0 30px 60px;
    .h5 {
      border: 1px solid #ccc;
      width: 80px;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
    }
    .form {
      margin-top: 10px;
      li {
        height: 30px;
        line-height: 30px;
        margin-bottom: 10px;
        span {
          font-weight: 700;
          margin-right: 20px;
        }
        input {
          width: 340px;
          height: 28px;
          border: 1px solid #ccc;
          font-size: 16px;
          padding-left: 10px;
        }
      }
    }
    p {
      font-weight: 700;
      line-height: 30px;
      input {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        margin-right: 10px;
      }
    }
    .btn {
      margin-top: 10px;
      a {
        display: inline-block;
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #F3C622;
        color: #fff;
        border-radius: 5px;
        margin-right: 10px;
      }
    }
    .container {
      padding-left: 20px;
      margin-top: 50px;
      ol {
        display: flex;
        height: 40px;
        line-height: 40px;
        border: 1px solid #ccc;
        background: #eee;
      }
      .body {
        h6 {
          padding-left: 10px;
          line-height: 40px;
          font-weight: 700;
          height: 40px;
          font-size: 18px;
        }
        .site {
          border: 1px solid #ccc;
        }
        ul {
          height: 40px;
          display: flex;
          li {
            overflow: hidden;
            a {
              color: #F3C622;
              &:hover {
                color: red;
              }
            }
          }
          //   .flex2 {
          //     text-align: left;
          //   }
        }
      }
      li {
        float: left;
        flex: 1;
        text-align: center;
      }
      .flex2 {
        flex: 2;
      }
    }
  }
}
</style>